import { api } from './index';

export type StatusCount = { status: string; count: number };

export interface DashboardWorkItem {
  type: string;
  id: string;
  reference: string;
  title: string;
  status: string;
  updatedAt: string;
  path: string;
}

export interface DashboardOverview {
  role: string;
  generatedAt: string;
  myPending: {
    total: number;
    items: Array<{ key: string; label: string; count: number; path: string }>;
  };
  /** The user's own drafts and rejected forms (procurement roles only). */
  myReturned: DashboardWorkItem[];
  /** Null for roles that don't work with contracts. */
  contracts: {
    byStatus: StatusCount[];
    activeValue: number;
    consumedValue: number;
    remainingValue: number;
    expiringCount: number;
    expiring: Array<{
      id: string;
      contractNumber: string;
      title: string;
      supplierName: string;
      endDate: string | null;
      daysLeft: number | null;
      contractValue: number;
      consumedValue: number;
    }>;
  } | null;
  upcomingMeetings: Array<{
    id: string;
    meetingNumber: string;
    title: string;
    location: string;
    plannedStart: string;
    status: string;
    agendaCount: number;
  }>;
  pipeline: Array<{ key: string; label: string; path: string; statuses: StatusCount[] }>;
  recentActivity: DashboardWorkItem[];
}

export const dashboardApi = {
  getOverview: async (): Promise<DashboardOverview> => {
    const response = await api.get<DashboardOverview>('/dashboard/overview');
    return response.data;
  },
};
